import _slicedToArray from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import IMask from '../core/holder.js';
import MaskedPattern from './pattern.js';
import '../core/change-details.js';
import '../core/utils.js';
import './base.js';
import '../core/continuous-tail-details.js';
import './factory.js';
import './pattern/chunk-tail-details.js';
import './pattern/cursor.js';
import './pattern/fixed-definition.js';
import './pattern/input-definition.js';
import './regexp.js';
/** Pattern which accepts ranges */

var MaskedRange =
/*#__PURE__*/
function (_MaskedPattern) {
  _inherits(MaskedRange, _MaskedPattern);

  _createClass(MaskedRange, [{
    key: "_matchFrom",

    /**
      Optionally sets max length of pattern.
      Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
    */

    /** Min bound */

    /** Max bound */

    /** */
    get: function get() {
      return this.maxLength - String(this.from).length;
    }
  }]);

  function MaskedRange(opts) {
    _classCallCheck(this, MaskedRange);

    return _possibleConstructorReturn(this, _getPrototypeOf(MaskedRange).call(this, opts)); // mask will be created in _update
  }

  _createClass(MaskedRange, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      _get(_getPrototypeOf(MaskedRange.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var _opts$to = opts.to,
          to = _opts$to === void 0 ? this.to || 0 : _opts$to,
          _opts$from = opts.from,
          from = _opts$from === void 0 ? this.from || 0 : _opts$from,
          _opts$maxLength = opts.maxLength,
          maxLength = _opts$maxLength === void 0 ? this.maxLength || 0 : _opts$maxLength,
          _opts$autofix = opts.autofix,
          autofix = _opts$autofix === void 0 ? this.autofix : _opts$autofix,
          patternOpts = _objectWithoutProperties(opts, ["to", "from", "maxLength", "autofix"]);

      this.to = to;
      this.from = from;
      this.maxLength = Math.max(String(to).length, maxLength);
      this.autofix = autofix;
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var sameCharsCount = 0;

      while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) {
        ++sameCharsCount;
      }

      patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);

      _get(_getPrototypeOf(MaskedRange.prototype), "_update", this).call(this, patternOpts);
    }
  }, {
    key: "boundaries",
    value: function boundaries(str) {
      var minstr = '';
      var maxstr = '';

      var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [],
          _ref2 = _slicedToArray(_ref, 3),
          placeholder = _ref2[1],
          num = _ref2[2];

      if (num) {
        minstr = '0'.repeat(placeholder.length) + num;
        maxstr = '9'.repeat(placeholder.length) + num;
      }

      minstr = minstr.padEnd(this.maxLength, '0');
      maxstr = maxstr.padEnd(this.maxLength, '9');
      return [minstr, maxstr];
    }
  }, {
    key: "doPrepareChar",
    value: function doPrepareChar(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }

      var details;

      var _get$call = _get(_getPrototypeOf(MaskedRange.prototype), "doPrepareChar", this).call(this, ch.replace(/\D/g, ''), flags);

      var _get$call2 = _slicedToArray(_get$call, 2);

      ch = _get$call2[0];
      details = _get$call2[1];
      if (!this.autofix || !ch) return [ch, details];
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var nextVal = this.value + ch;
      if (nextVal.length > this.maxLength) return ['', details];

      var _this$boundaries = this.boundaries(nextVal),
          _this$boundaries2 = _slicedToArray(_this$boundaries, 2),
          minstr = _this$boundaries2[0],
          maxstr = _this$boundaries2[1];

      if (Number(maxstr) < this.from) return [fromStr[nextVal.length - 1], details];

      if (Number(minstr) > this.to) {
        if (this.autofix === 'pad' && nextVal.length < this.maxLength) {
          return ['', details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))];
        }

        return [toStr[nextVal.length - 1], details];
      }

      return [ch, details];
    }
  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      var str = this.value;
      var firstNonZero = str.search(/[^0]/);
      if (firstNonZero === -1 && str.length <= this._matchFrom) return true;

      var _this$boundaries3 = this.boundaries(str),
          _this$boundaries4 = _slicedToArray(_this$boundaries3, 2),
          minstr = _this$boundaries4[0],
          maxstr = _this$boundaries4[1];

      return this.from <= Number(maxstr) && Number(minstr) <= this.to && _get(_getPrototypeOf(MaskedRange.prototype), "doValidate", this).call(this, flags);
    }
  }, {
    key: "isComplete",
    get: function get() {
      return _get(_getPrototypeOf(MaskedRange.prototype), "isComplete", this) && Boolean(this.value);
    }
  }]);

  return MaskedRange;
}(MaskedPattern);

IMask.MaskedRange = MaskedRange;
export { MaskedRange as default };